import React, { useState } from "react";

import { Grid, Step, Segment } from "semantic-ui-react";

import ConformiteAdd1 from "./conformiteAdd1";
import ConformiteAdd2 from "./conformiteAdd2";
import ConformiteAdd3 from "./conformiteAdd3";
import ConformiteAdd4 from "./conformiteAdd4";

const ConformiteAdd = ({ userList }) => {
  const [step, setStep] = useState(1);

  const next = () => {
    setStep(step + 1);
  };

  const prev = () => {
    setStep(step - 1);
  };

  const StepDisplay = ({ step, next, prev }) => {
    switch (step) {
      case 1:
        return <ConformiteAdd1 next={next} userList={userList} />;
      case 2:
        return <ConformiteAdd2 prev={prev} next={next} />;
      case 3:
        return <ConformiteAdd3 prev={prev} next={next} userList={userList}/>;
      case 4:
        return <ConformiteAdd4 prev={prev} next={next} />;
      default:
        return null;
    }
  };

  return (
    <Segment.Group>
      <Segment>
        <Grid>
          <Grid.Column width={16}>
            <div align="center">
              <Step.Group>
                <Step completed={step > 1} active={step === 1}>
                  <i className="cloud download icon"></i>
                  <Step.Content>
                    <Step.Title>Description</Step.Title>
                    <Step.Description>Description</Step.Description>
                  </Step.Content>
                </Step>

                <Step completed={step > 2} active={step === 2}>
                  <i className="laptop icon"></i>
                  <Step.Content>
                    <Step.Title>Analyse et traitement</Step.Title>
                    <Step.Description>Analyse et traitement</Step.Description>
                  </Step.Content>
                </Step>

                <Step completed={step > 3} active={step === 3}>
                  <i className="paperclip icon"></i>
                  <Step.Content>
                    <Step.Title>Efficacite et suivi des actions</Step.Title>
                    <Step.Description>
                      Efficacite et suivi des actions
                    </Step.Description>
                  </Step.Content>
                </Step>

                <Step completed={step > 4} active={step === 4}>
                  <i className="lock icon"></i>
                  <Step.Content>
                    <Step.Title>Récapitulatif</Step.Title>
                    <Step.Description>récapitulatif</Step.Description>
                  </Step.Content>
                </Step>
              </Step.Group>
            </div>
            <Segment.Group>
              <StepDisplay step={step} next={next} prev={prev} />
            </Segment.Group>
          </Grid.Column>
        </Grid>
      </Segment>
    </Segment.Group>
  );
};

export default ConformiteAdd;
